<div class="ai-chat-dialog" *ngIf="isOpen | async">
  <div class="ai-chat-header">
    <span>{{ 'ai_chat.header.title' | transloco }} <span class="ai-beta-badge">{{ 'ai_chat.header.beta' | transloco }}</span></span>
    <one-icon name="close" (click)="closeChat()"></one-icon>
  </div>
  <div class="ai-chat-messages">
    <div *ngFor="let msg of messages" class="ai-chat-message" [class._user]="msg.role === 'user'">
      <div class="ai-chat-message-content">{{msg.content.message}}</div>
      @if (msg.content.redirect_url) {
        <div class="ai-chat-message-redirect">
          <a class="one-button black outline xs mt-1" [routerLink]="msg.content.redirect_url">
            {{ 'ai_chat.view_result' | transloco }}
          </a>
        </div>
      }
    </div>
    <div *ngIf="isLoading" class="ai-chat-message ai-chat-loading">
      <div class="ai-chat-loading-indicator">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  </div>
  
  <div *ngIf="visibleQuickActions.length > 0" class="ai-chat-quick-actions-grouped">
    <ng-container *ngFor="let section of visibleQuickActions | groupBySection">
      <div class="quick-action-section-header">{{ translateSectionName(section.name, section.actions) }}:</div>
      <div class="ai-chat-quick-actions">
        <button 
          *ngFor="let action of section.actions" 
          class="one-button black outline xs"
          (click)="executeQuickAction(action)">
          {{ translateActionLabel(action) }}
        </button>
      </div>
    </ng-container>
  </div>
  
  <div class="ai-chat-input">
    <input 
      type="text" 
      [(ngModel)]="message" 
      [placeholder]="'ai_chat.input_placeholder' | transloco"
      (keyup.enter)="sendMessage()"
    >
    <one-icon name="send" (click)="sendMessage()"></one-icon>
  </div>
</div>
